/*
 * @Descripttion:
 * @Author: baiyang
 * @Date: 2022-03-01 15:39:22
 * @LastEditors: baiyang
 * @LastEditTime: 2022-03-10 15:56:09
 */

const version = wx.getSystemInfoSync().SDKVersion || '1.1.0'
/**
* @function 官方版本判断
* @author by
* @param v1 {string} 当前版本号
* @param v2 {string} 支持版本号
*/
export const compareVersion = (v1, v2) => {
  v1 = v1.split('.')
  v2 = v2.split('.')
  const len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    // eslint-disable-next-line radix
    const num1 = parseInt(v1[i])
    // eslint-disable-next-line radix
    const num2 = parseInt(v2[i])
    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }
  return 0
}


/**
* @function 获取时间
* @author by
*/
export const getTimeTamp = () => {
  const time = Date.parse(new Date()) / 1000
  return time
}
/**
 * @function 微信半屏打开小程序
 * @author by
 * @param {string} appId 小程序id
 * @param {string} path 跳转小程序页面地址
 * @return {string} message 打开状态
 */
export const openEmbeddedMiniProgram = (appId = '', path = '') => new Promise((resolve) => {
  const appData = (name) => ({
    appId,
    path,
    success(res) {
      console.log('打开成功', res)
      resolve({
        message: `${name}打开状态：${JSON.stringify(res)}`,
        success: true
      })
    },
    fail(res) {
      console.log('打开失败', res)
      resolve({
        message: `${name}打开状态：${JSON.stringify(res)}`,
        success: false
      })
    },
    complete(res) {
      console.log(res)
      // 调用结束  不管成功还是失败都执行
    }
  })
  if (compareVersion(version, '2.20.1') >= 0) {
    wx.openEmbeddedMiniProgram(appData('半屏'))
  } else {
    wx.navigateToMiniProgram(appData('直跳'))
  }
})
